// extracted by mini-css-extract-plugin
export default {"title":"EditProfile_title__Z1YH3","create-client-form":"EditProfile_create-client-form__9jmz7","save-modal":"EditProfile_save-modal__nfRhZ"};